export const OTP_HEADER = "Enter verification code"

export const OTP_SUBHEADER = "We texted you a code to **phone_number**. It may take a few minutes to arrive. Enter the code below to verify."
